module.exports = __webpack_public_path__ + "static/img/gongsidontai.a74569b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/icons/gongsidontai.png
// module id = W/7p
// module chunks = 6